import { captureException, SeverityLevel, withScope } from '@sentry/react'
import { getIsSentryEnabled } from 'ComponentLibrary/src/common/environment'

export const sendToSentry = (error: Response | Error | unknown, level: SeverityLevel = 'error') => {
    if (getIsSentryEnabled()) {
        withScope(function (scope) {
            scope.setLevel(level)
            captureException(error)
        })
    }
}

export function sendDebugInfoToSentry(error: unknown) {
    sendToSentry(error, 'info')
}
